import { ScreenreaderService } from '@klant/conversational-connector/services/screenreader/screenreader.service';
import { MessageHandlerService } from '@klant/conversational-connector/services/message-handle-service/message-handler.service';
import { UnreadMessageService } from '@klant/conversational-connector/services/unread-message-service/unread-message.service';
import { ConversationService } from '@klant/conversational-connector/services/conversation/conversation.service';
import { WebsocketService } from '@klant/conversational-connector/services/wsservice/websocket.service';
import { ConversationLifecycleService } from '@klant/conversational-connector/services/conversation-life-cycle-service/conversation-life-cycle.service';
import { FaqMessageService } from '@klant/conversational-connector/services/faq-message-service/faq-message.service';
import { InactivityService } from '@klant/conversational-connector/services/inactivity-service/inactivity.service';

import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { ApContentService } from '@ap/content';

import { ConversationalChatStore } from '../../signal-stores/conversational-chat-store/conversational-chat.store';

import content from './klant-conversational-connector.content.json';
import { ActionModel, ConversationalChatVisibility } from './klant-conversational-connector.model';
import { KlantConversationalConnectorService } from './klant-conversational-connector.service';

@Component({
    selector: 'klant-conversational-connector',
    templateUrl: './klant-conversational-connector.component.html',
    standalone: false
})
export class KlantConversationalConnectorComponent implements OnInit {
    protected readonly conversationalChatStore = inject(ConversationalChatStore);

    private readonly contentService = inject(ApContentService);
    private readonly conversationLifecycleService = inject(ConversationLifecycleService);
    private readonly conversationService = inject(ConversationService);
    private readonly faqMessageService = inject(FaqMessageService);
    private readonly inactivityService = inject(InactivityService);
    protected readonly klantConversationalConnectorService = inject(KlantConversationalConnectorService);
    private readonly messageHandlerService = inject(MessageHandlerService);
    private readonly unreadMessageService = inject(UnreadMessageService);
    protected readonly webSocketService = inject(WebsocketService);
    protected readonly screenreaderService = inject(ScreenreaderService);
    readonly #destroyRef = inject(DestroyRef);

    constructor() {
        this.markMessagesReadOnChatOpen();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);

        this.klantConversationalConnectorService.faqMessage$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((faqMessage: string) => {
            if (faqMessage) {
                this.faqMessageService.sendFaqMessage();
            }
        });
    }

    public onSendMessage(text: string): void {
        this.messageHandlerService.sendMessage(text);
    }

    public onSendAction(actionModel: ActionModel): void {
        this.messageHandlerService.sendAction(actionModel);
    }

    public refreshChatComponent(): void {
        this.conversationLifecycleService.createConversation();
    }

    public promptContinueConversation(): void {
        this.inactivityService.promptContinue();
    }

    public promptEndConversation(): void {
        this.inactivityService.promptEnd();
    }

    public hideLiveChatFaqPopUp(): void {
        this.conversationalChatStore.setShowLiveChatFaqPopUp(false);
    }

    private markMessagesReadOnChatOpen(): void {
        toObservable(this.conversationService.getChatVisibility)
            .pipe(takeUntilDestroyed())
            .subscribe((visibility: ConversationalChatVisibility) => {
                if (this.webSocketService.subject && visibility === ConversationalChatVisibility.OPEN) {
                    this.unreadMessageService.markMessagesAsRead(this.conversationalChatStore.unreadChatMessages());
                }
            });
    }
}
